import { Button } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import type { TooltipRenderProps } from 'react-joyride';

import { TourClasses, useTourStore } from '@revelio/core';

import { isElementVisible, pollUntil } from './tour.utils';

const CompositionPageStepCustomTooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  skipProps,
  primaryProps,
  tooltipProps,
}: TooltipRenderProps) => {
  const [canContinue, setCanContinue] = useState(false);
  const setHasTouredCompositions = useTourStore(
    (s) => s.setHasTouredCompositions
  );

  useEffect(() => {
    const areTargetsReady = () => {
      const entitiesTarget = document.querySelector(
        `.${TourClasses.TOUR_TRACKING_CLASS}`
      );
      const filtersTarget = document.querySelector(
        `.${TourClasses.TOUR_FILTER_MENU_CLASS}`
      );

      const entitiesReady =
        entitiesTarget instanceof HTMLElement &&
        isElementVisible(entitiesTarget);
      const filtersReady =
        filtersTarget instanceof HTMLElement && isElementVisible(filtersTarget);

      return entitiesReady && filtersReady;
    };

    const cancelPolling = pollUntil(
      areTargetsReady,
      () => setCanContinue(true),
      () => setCanContinue(true) // allow continue even on timeout
    );

    setHasTouredCompositions(true);

    return cancelPolling;
  }, [setHasTouredCompositions]);

  return (
    <div style={step.styles?.tooltip} data-testid="custom-compositions-tooltip">
      <div {...tooltipProps} style={step.styles?.tooltipContainer}>
        <h4 style={step.styles?.tooltipTitle}>{step.title}</h4>
        <div style={step.styles?.tooltipContent}>{step.content}</div>
        <div style={step.styles?.tooltipFooter}>
          <Button {...skipProps} style={step.styles?.buttonSkip}>
            Skip Tour
          </Button>
          {index > 0 && (
            <Button {...backProps} style={step.styles?.buttonBack}>
              Back
            </Button>
          )}
          {continuous && (
            <Button
              {...primaryProps}
              style={step.styles?.buttonNext}
              isLoading={!canContinue}
            >
              Next ({index + 1}/{size})
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompositionPageStepCustomTooltip;
